module.exports = __webpack_public_path__ + "static/black-box-thinking-e93dca27ae7012fd293dad4fc194f8ad.jpg";